module.exports = __webpack_public_path__ + "img/logo-oqlf-marges.1cac2e99.svg";